import React from 'react';
import RentalsProductItem from '@jucy-nakuru/common/services/JucyRentalsApi/RentalsProductItem';
import { Money } from '@jucy/rentals-api-client';
import { ProductLine } from '@jucy/rentals-api-client/rentals-api-v3/models/ProductLine';
import { formatCurrency } from '../../../lib/currency';
import { formatUnitTitle } from '../../../lib/formatUnitTitle';
import BookingSummaryPanelRow, { SummaryPanelRowProps } from './BookingSummaryPanelRow';

interface SummaryPanelProductRowProps extends Omit<SummaryPanelRowProps, 'title' | 'subtitle' | 'value'> {
    item: RentalsProductItem | ProductLine;
    amendedItem?: ProductLine;
}

export const BookingSummaryPanelProductRowComponent: React.FC<React.PropsWithChildren<SummaryPanelProductRowProps>> = ({
    item,
    amendedItem,
    ...props
}) => {
    let title = '';
    let subtitle = '';
    if (item) {
        const { titlePrefix, unitTitle } = formatUnitTitle({
            type: item.productType,
            quantity: 'quantity' in item ? item.quantity : item.qty,
            price: item.price,
            rentalDays: item.rentalDays,
            allowMultiple: item.allowMultiple,
        });
        title = `${titlePrefix} ${item.name}`;
        subtitle = unitTitle;
    }

    return <BookingSummaryPanelRow title={title} subTitle={subtitle} value={formatCurrency(item.total as Required<Money>)} {...props} />;
};

const BookingSummaryPanelProductRow: React.FC<React.PropsWithChildren<SummaryPanelProductRowProps>> = ({ item, amendedItem, ...props }) => {
    const hasAmendment = Boolean(
        amendedItem && (amendedItem?.isExcluded || amendedItem.total.value !== item.total.value || item.productId !== amendedItem.productId)
    );
    if (!hasAmendment && item.quantity === 0) {
        return;
    }
    const showAmendment = Boolean(hasAmendment && amendedItem?.qty && !amendedItem?.isExcluded);
    return (
        <>
            <BookingSummaryPanelProductRowComponent
                sx={{ textDecoration: hasAmendment || item.isExcluded ? 'line-through' : undefined }}
                item={item}
                {...props}
            />
            {showAmendment && amendedItem ? <BookingSummaryPanelProductRowComponent item={amendedItem} isAlwaysShowPrice={true} /> : null}
        </>
    );
};

export default BookingSummaryPanelProductRow;
